import React, { useState } from 'react';

import { array, bool, number, oneOfType, string } from 'prop-types';
import { generate } from 'shortid';

import { FullContainer } from '../../styles';

import HeaderBackDrop from './HeaderBackDrop';
import { CatContainer, ListCategories, ListItemCategorie, LinkCategories } from './styles';

function HeaderBottom({ menu, isSearchBox, maxWidth }) {
  const [current, setCurrent] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);

  const handleMenu = (menuOpen) => () => {
    if (!isSearchBox) {
      setOpenMenu(menuOpen);

      if (!menuOpen) {
        setCurrent(false);
      }
    }
  };

  function handleCurrent(idx, children) {
    if (!isSearchBox) {
      if (!children || !children.length) {
        setOpenMenu(false);
        setCurrent(false);
        return;
      }

      setOpenMenu(true);
      setCurrent(idx);
    }
  }

  return (
    <FullContainer container justifyContent="center" maxwidth={maxWidth}>
      <CatContainer onMouseEnter={handleMenu(true)} onMouseLeave={handleMenu(false)}>
        {menu && (
          <ListCategories>
            {menu.map((item, idx) => (
              <ListItemCategorie
                key={generate()}
                iscurrent={current === idx ? 'true' : null}
                onMouseEnter={() => handleCurrent(idx, item.children)}
                background={item.background}
                fontcolor={item.fontColor}
              >
                <LinkCategories href={`${item.link}`} title={item.title} textalign="center">
                  {item.title}
                </LinkCategories>
              </ListItemCategorie>
            ))}
          </ListCategories>
        )}
        {openMenu && <HeaderBackDrop openMenu={openMenu} subMenu={menu[current]} handleMenu={handleMenu} />}
      </CatContainer>
    </FullContainer>
  );
}

HeaderBottom.defaultProps = {
  menu: [],
};

HeaderBottom.propTypes = {
  menu: array,
  isSearchBox: bool,
  maxWidth: oneOfType([number, string]),
};

export default HeaderBottom;
